import type { LatLngExpression } from 'leaflet'

export type GIPointCollection = {
  id: number
  project: number
  name: string
  source_files: File[]
  description: string
  gipoint_set: {
    features: GroundInvestigationPoint[]
    type: 'FeatureCollection'
  }
  collection_color: string
}

export type GroundInvestigationPoint = {
  id: number
  type: 'Feature'
  geometry: Geometry
  properties: Properties
}

export enum GenericGIType {
  BOREHOLE_GENERIC = 'BoreholeGeneric',
  CPT_GENERIC = 'CPTGeneric'
}

export enum GITypeDisplay {
  BOREHOLE = 'Borehole',
  CPT = 'CPT',
  UNKNOWN = 'Unknown'
}

export type Properties = {
  gi_data_upload_collection: number
  gi_type: string
  location_id: string
  survey_datestring: string
  survey_company: string
  end_depth: number
  cpt: Object
  borehole: Object
  generic_gi_type: GenericGIType
}

export type Geometry = {
  type: 'Point'
  coordinates: LatLngExpression
}
